export const mixpanel = {
    name: 'Mixpanel',
    key: 'mixpanel',
    assets: {
        icon: '/images/competitors/mixpanel.svg',
        comparisonArticle: '/blog/posthog-vs-mixpanel',
    },
    available: true,
    products: {
        product_analytics: {
            available: true,
            pricing: {
                free_tier: '1 million events',
            },
            features: {
                advertising_analytics: false,
                autocapture: true,
                cohorts: true,
                custom_events: true,
                custom_properties: true,
                monetization_analytics: false,
                predictive_insights: false,
                real_time_view: false,
                toolbar: false,
                user_profiles: true,
                insights: {
                    available: true,
                    features: {
                        ai_insight_builder: true,
                        alerts: true,
                        formula_mode: true,
                        ready_made_insight_types: true,
                        sampling: false,
                        sql_editor: 'JQL only',
                    },
                },
                trends: {
                    available: true,
                    features: {},
                },
                funnels: {
                    available: true,
                    features: {
                        correlation_analysis: true,
                    },
                },
                retention: {
                    available: true,
                    features: {},
                },
                user_paths: {
                    available: true,
                    features: {},
                },
                lifecycle: {
                    available: true,
                    features: {},
                },
                stickiness: {
                    available: true,
                    features: {},
                },
                group_analytics: {
                    available: true,
                    features: {},
                },
            },
        },
        web_analytics: {
            available: true,
            features: {
                advertising_analytics: false,
                bounce_rate: true,
                bounce_rate_tracking: false,
                breakdown_by_device_and_browser: false,
                breakdown_by_geoip: false,
                clickmaps: true,
                conversions: true,
                cookieless_tracking: false,
                custom_channel_types: true,
                entry_exit_paths: true,
                first_party_cookies: false,
                heatmaps: false,
                hipaa_compliance: false,
                integration_with_feature_flags: false,
                integration_with_session_replay: false,
                integration_with_surveys: false,
                migration: false,
                movement_maps: false,
                open_source: false,
                outbound_clicks: true,
                pageviews: true,
                pre_configured_dashboards: false,
                real_time_reporting: false,
                revenue_tracking: false,
                script_size: false,
                scrollmaps: false,
                session_and_duration_tracking: false,
                sessions: true,
                snippet_install: false,
                traffic_breakdown: true,
                utm_tracking: true,
                visitor_and_view_tracking: false,
                web_vitals: false,
                web_vitals_reporting: false,
            },
        },
        session_replay: {
            available: true,
            pricing: {
                free_tier: 'Unknown',
            },
            features: {
                canvas_recording: false,
                chat_with_recordings: false,
                clickmaps: false,
                conditional_recording: false,
                event_timeline: true,
                export_to_json: false,
                export_to_video: false,
                filter_by_user_or_event: true,
                identity_detection: true,
                iframe_recording: false,
                minimum_duration: false,
                movement_maps: false,
                notes_on_replays: false,
                playlists: false,
                privacy_masking: true,
                retention_policy: true,
                screenshot_mode: true,
                scrollmaps: false,
                search_by_network: false,
                share_replays: false,
                single_page_app: false,
                target_by_feature_flag: false,
                target_by_sample: true,
                target_by_url: true,
                wireframe_mode: false,
            },
            platform_support: {
                features: {
                    web_app_recordings: true,
                    mobile_app_recordings: 'iOS Beta',
                    ios_recordings: 'Closed Beta',
                    android_recordings: false,
                    react_native_recordings: false,
                    flutter_recordings: false,
                },
            },
            analysis: {
                features: {
                    heatmaps: true,
                    console_logs: false,
                    performance_monitoring: false,
                    network_monitor: false,
                    dom_explorer: false,
                },
            },
            ai: {
                features: {
                    ai_summaries: false,
                },
            },
        },
        feature_flags: {
            available: false,
            features: {
                boolean_flags: false,
                early_access_management: false,
                json_payloads: false,
                multivariate_flags: false,
                release_conditions: false,
            },
            implementation: {
                features: {
                    local_evaluation: false,
                    bootstrapping: false,
                },
            },
            targeting: {
                features: {
                    target_by_percentage: false,
                    target_by_person_properties: false,
                    target_by_cohorts: false,
                },
            },
            management: {
                features: {
                    approvals: false,
                    multi_environment: false,
                    flag_administration: false,
                    flag_scheduling: false,
                    history_activity: false,
                },
            },
            testing: {
                features: {
                    flag_overrides: false,
                    toolbar_integration: false,
                    user_assignment: false,
                },
            },
        },
        experiments: {
            available: 'Analysis only',
            pricing: {
                free_tier: false,
            },
            features: {
                count_value_metrics: false,
                custom_goals: true,
                dynamic_cohorts: false,
                experiment_analysis: true,
                funnel_metrics: false,
                namespacing: false,
                native_goal_tracking: false,
                no_code_experiments: false,
                ratio_metrics: false,
                recommended_run_time: false,
                secondary_metrics: true,
                shared_metrics_library: false,
                split_testing: false,
                visual_editor: false,
            },
            supported_tests: {
                features: {
                    aa_testing: false,
                    ab_testing: false,
                    abn_testing: false,
                    data_warehouse_experiments: false,
                    fake_door_testing: false,
                    holdout_testing: false,
                    multi_armed_bandit: false,
                    mutually_exclusive_experiments: false,
                    redirect_testing: false,
                },
            },
            targeting: {
                features: {
                    cohort_integration: false,
                    exclusion_rules: false,
                    geographic_targeting: false,
                    group_level_experiments: false,
                    holdouts: false,
                    target_by_percentage: false,
                },
            },
            implementation: {
                features: {
                    api_access: false,
                    feature_flag_foundation: false,
                    json_payloads: false,
                    multivariate_testing: false,
                },
            },
            analysis: {
                features: {
                    results_visualization: false,
                    side_effect_monitoring: false,
                    statistical_significance: true,
                    statistics_engine: 'Frequentist',
                },
            },
            platforms: {
                features: {
                    mobile: false,
                    web: false,
                },
            },
        },
        heatmaps: {
            available: false,
            features: {
                clickmaps: true,
                heatmaps: false,
                rage_clicks: true,
                scrollmaps: false,
            },
        },
        surveys: {
            available: false,
            features: {
                aggregated_results: false,
                ai_response_summaries: false,
                automatic_nps_calculation: false,
                capture_partial_responses: false,
                completion_conditions: false,
                custom_targeting: false,
                customizable_wait_periods: false,
                linked_feature_flag: false,
                nps_surveys: false,
                pmf_surveys: false,
                sdk_support: false,
                sentiment_analysis: false,
                slack_integration: false,
                survey_templates: false,
                target_by_feature_flag: false,
                user_interview_requests: false,
                webhooks: false,
            },
            targeting: {
                features: {
                    custom_targeting: false,
                    display_conditions: false,
                    event_triggered: false,
                },
            },
            presentation: {
                features: {
                    feedback_button: false,
                    custom_html: false,
                    custom_ui: false,
                    conditional_logic: false,
                },
            },
            branching: {
                features: {
                    conditional_logic: false,
                },
            },
            question_types: {
                features: {
                    freeform_text: false,
                    multiple_choice: false,
                    multi_select: false,
                    rating: false,
                    emoji_reaction: false,
                    interview_scheduling: false,
                },
            },
            platforms: {
                features: {
                    web: false,
                    mobile: false,
                },
            },
            implementation: {
                features: {
                    api_access: false,
                },
            },
        },
        error_tracking: {
            available: false,
        },
        llm_analytics: {
            available: false,
        },
        data_pipelines: {
            available: true,
        },
        cdp: {
            available: false,
        },
        data_warehouse: {
            available: false,
        },
        dashboards: {
            available: true,
            features: {},
        },
        revenue_analytics: {
            available: true,
            features: {
                revenue_tracking: true,
                event_based_revenue_tracking: true,
                native_multi_source_revenue_tracking: false,
                deferred_revenue: false,
                product_analytics_integration: true,
                multi_currency_support: false,
                revenue_prediction: false,
                sql_access: false,
            },
        },
    },
    platform: {
        deployment: {
            eu_hosting: true,
            managed_reverse_proxy: false,
            open_source: 'Libraries only',
            self_host: false,
        },
        pricing: {
            free_tier: true,
            transparent_pricing: false,
            usage_based_pricing: true,
            self_serve: true,
        },
        integrations: {
            ci_cd_integrations: false,
            community_integrations: false,
            customer_io: true,
            datadog: false,
            exports: false,
            google_ads: false,
            hubspot: true,
            imports: false,
            intercom: true,
            microsoft_teams: false,
            rudderstack: true,
            segment: true,
            sentry: false,
            slack: false,
            stripe: false,
            warehouse_import: true,
            zapier: true,
            zendesk: false,
        },
        security: {
            gdpr_ready: true,
            hipaa_ready: true,
            history_audit_logs: true,
            role_based_access_control: true,
            saml_sso: 'Enterprise',
            soc2_certified: true,
            two_factor_auth: true,
            user_privacy_options: true,
        },
        developer: {
            api: false,
            proxies: false,
            sdks: false,
            sql: false,
        },
        tools: {
            cms: '',
            notebooks: true,
            project_management_tools: '',
        },
    },
    pricing: {
        model: 'Usage-based',
    },
}
